import { Component, EventEmitter, Input, Output } from '@angular/core'
import { DialogService } from '../../../../../../services'
import { SearchAdresseComponent } from '../search-adresse/search-adresse.component'

@Component({
	selector: 'app-form-input-adresse-shared',
	templateUrl: './form-input-adresse-shared.component.html',
	styleUrls: ['./form-input-adresse-shared.component.scss']
})
export class FormInputAdresseSharedComponent {
	@Output() selected: EventEmitter<any> = new EventEmitter<any>()
	@Input() tiers: any
	@Input() active = true;
	@Input() selectedTiers: any
	constructor(
		private readonly dialogService: DialogService
	) { }

	openAdresseDialog(event: MouseEvent) {
		event.stopPropagation()
		this.dialogService.open(SearchAdresseComponent, {
			width: '60vw',
			height: '30vh',
			draggable: true,
			minimizable: true,
			maximizable: true,
			resizable: true,
			data: {
				tiers: this.tiers,
				selectedTiers: this.selectedTiers
			}
		}, (result: any) => {
			if (result) {
				this.selected.emit(result)
			}
		})
	}
	sharedAdresseSelected(selectedTiers: any) {
		this.selected.emit(selectedTiers)
	}
}
